import { ChangeDetectionStrategy, Component, NgModule } from '@angular/core';
import { FieldArrayType, FormlyModule } from '@ngx-formly/core';
import { NgForOf } from '@angular/common';
import { PortalFieldTypeConfig } from '@portal/form/data-access';

@Component({
  selector: 'portal-form-array',
  standalone: true,
  imports: [NgForOf, FormlyModule],
  template: `
    <ng-container *ngFor="let f of field.fieldGroup; let i = index">
      <formly-field [field]="f"></formly-field>
    </ng-container>
  `,
  styles: [':host {display: block;}'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ArrayComponent extends FieldArrayType<PortalFieldTypeConfig> {}

@NgModule({
  imports: [FormlyModule.forChild({ types: [{ name: 'array', component: ArrayComponent }] })],
})
export class FormArrayModule {}
